import React, { useState, useEffect } from 'react'
import { useCallback } from 'react'
import { BiSearch,BiX } from 'react-icons/bi'
import { Outlet, useNavigate } from 'react-router-dom'

import Sidebar from '../../components/Sidebar/Sidebar'
import './Layout.css'

const SearchForm = ({ searchTerm, handleOnChange, handleSubmit}) => {
  return(
    <>
      <form>
        <input 
          className='search'
          type='search'
          placeholder='Search...'
          value={searchTerm}
          onChange={handleOnChange}
        />
        <button aria-label='search button' type='submit' onClick={handleSubmit}><BiSearch className={'icon'}/></button>
        </form>
    </>
  )
}
const Layout = () => {
  
  return (
    <div className='main'>
      <Header />
      <div className='main-content'>
        <Sidebar/>
        <Outlet />
      </div>
      <footer>
        <span>Copyright © 2022 - All rights reserved</span>
        <br />
        <a href="https://www.flaticon.com/free-icons/game-boy-advance" title="game boy advance icons">Game boy advance icons created by Freepik - Flaticon</a>
      </footer>
    </div>
  )
}
const Header = () => {
  const [bigScreen, setBigScreen] = useState(
    window.matchMedia("(min-width: 768px)").matches
  )
  const [searchTerm, setSearchTerm] = useState('');
  const [showSearch, setShowSearch] = useState(false);
  let navigate = useNavigate();
  
  const handleWidthChange = useCallback((e) => {
    setBigScreen( e.matches )
  }, [setBigScreen]) 
  useEffect(() => {
    window
    .matchMedia("(min-width: 768px)")
    .addEventListener('change',handleWidthChange);
    return ()=>window.matchMedia("(min-width: 768px)").removeEventListener('change', handleWidthChange)
  }, [handleWidthChange]);

  const handleSubmit = (e) => {
    e.preventDefault();
    navigate('/search?q=' + searchTerm)
    setSearchTerm('')
  }
  const handleOnChange = (e) => {
    setSearchTerm(e.target.value)
  }
  return (
    <header>
        <div className='header'>
          <div className='logo'>
            <div className='logo-main'>W D I P</div>
            <div className='logo-tagline'>What Do I Play?</div>
            <div className='logo-attribution'>Powered by <a href='http://rawg.io'>rawg.io</a></div>
          </div>
          {bigScreen && <SearchForm searchTerm={searchTerm} handleOnChange={handleOnChange} handleSubmit={handleSubmit} />}
          {(!bigScreen && !showSearch) && <button id='toggleSearch' onClick={()=>setShowSearch(true)}><BiSearch/></button>}
        </div>
        {showSearch && 
          <div style={{position:'relative'}}>
            <div className='mobileSearch'>
            <button id={'closeSearch'} onClick={()=>setShowSearch(false)}><BiX className={'icon'} />
            </button>
            <SearchForm searchTerm={searchTerm} handleOnChange={handleOnChange} handleSubmit={handleSubmit} />
            
            </div>
          </div>}
      </header>
  )
}

export default Layout